/**
 * Created by Administrator on 2017/4/24.
 */
import globalConfig from 'common/js/GlobalConfig';
import VueCookie from 'vue-cookie';

export default function (data){
  var url = data.url;
  var method = data.method;
  var successFun = data.success;
  var withCredentials = data.withCredentials;
  var dataBody = null;
  if(typeof data.data === "string"){
    dataBody = data.data;
  } else if(typeof data.data == "object"){
    var param = new Array();
    for(var i in data.data){
      param.push(i+"="+data.data[i]);
    }
    dataBody = param.join("&")
  }

  var xmlhttp = new XMLHttpRequest();
  if("withCredentials" in xmlhttp){
  }else if (window.XDomainRequest){
    xmlhttp = new XDomainRequest();
  } else {
    console.log("你的浏览器不支持!")
    return ;
  }
  if (xmlhttp != null) {
    xmlhttp.open(method, url);
    if(withCredentials){
      xmlhttp.withCredentials = true;
    }
    if (localStorage.getItem(globalConfig.STORAGE_TOKEN_NAME) && xmlhttp.setRequestHeader) {
      if(url.indexOf(globalConfig.domain.forensicsBackstage) > -1){
        xmlhttp.setRequestHeader("Authorization", 'Bearer ' + localStorage.getItem(globalConfig.STORAGE_TOKEN_NAME));
      }
    }
    if(dataBody && dataBody != null && dataBody != "" && xmlhttp.setRequestHeader){
      xmlhttp.setRequestHeader("content-type", "application/x-www-form-urlencoded");
    }
    xmlhttp.send( dataBody );
    xmlhttp.onload = function() {
      var data = xmlhttp.responseText;
      if(!data){
        data = xmlhttp.response;
      }
      if(typeof data === "string"){
        data = eval("("+data+")");
      }
      if(successFun && typeof successFun == "function"){
        var cookieToken = VueCookie.get(globalConfig.COOKIE_TOKEN_NAME);
        if (cookieToken) {
          localStorage.setItem(globalConfig.STORAGE_TOKEN_NAME, cookieToken);
          VueCookie.delete(globalConfig.COOKIE_TOKEN_NAME);
        }
        successFun(data);
      }else{
        console.log(data);
      }
    };
  } else {
    alert("Your browser does not support XMLHTTP.");
  }
}



// WEBPACK FOOTER //
// ./src/common/js/cors-ajax.js